<app-dialog
  [dialogType]="dialogType"
  [overflowHack]="true"
  [headerLabel]="'LABEL.ADD_ITEMS' | translate"
  [primaryActionText]="dialogButtonText$ | async"
  [primaryActionDisabled]="(numberOfSelectedItems$ | async) === 0"
  [hideActions]="false"
  [trackingObject]="trackingObject"
  [trackingScreenName]="trackingScreenName"
  [primaryActionTrackingAdditionalProperties]="
    itemsMultipleSelectTrackingProperties$ | async
  "
  [primaryActionTapped]="addBulkAction"
  [trackingAdditionalProperties]="trackingAdditionalProperties"
  (onPrimaryAction)="saveSelectedItems()"
  (onCloseAction)="onClose()"
>
  <div id="item-picker-dialog">
    <app-search
      class="search"
      [placeholder]="'LABEL.SEARCH' | translate"
      [actionTriggers]="searchActionTriggers$"
      (onSearchTermChange)="onSearch($event)"
    >
    </app-search>

    <app-feed
      class="feed scroll-container"
      [feed]="filteredItems$ | async"
      [noItemsOptions]="noItemsOptions"
      [trackByFn]="trackByFn"
    >
      <ng-template let-item="feedItem">
        <ng-container
          *ngIf="item.rate | money: item.currencyCode:item.locale as itemTotal"
        >
          <app-picker-dialog-list-item
            [bulkActionControl]="getBulkActionControl(item)"
            bulkActionFieldId="bulk_select_{{ item.id }}_field"
            [showHeader]="
              productNameEnabled ||
              (!productNameEnabled && showProductCode && !!item.code)
            "
            [header]="
              showProductCode && item.code
                ? item.code + ' - ' + item.name
                : item.name
            "
            [description]="productNameEnabled ? item.details : item.name"
            [subDescription]="
              displayItemType
                ? itemTotal +
                  ' - ' +
                  ((item.isPart() ? 'LABEL.PARTS' : 'LABEL.LABOR') | translate)
                : itemTotal
            "
            (onClickListItem)="onClickItem(item)"
          >
          </app-picker-dialog-list-item>
        </ng-container>
      </ng-template>
    </app-feed>

    <div *ngIf="error$ | async as error" class="error">
      {{ error }}
    </div>
  </div>
</app-dialog>
